import { useEffect } from 'react';

/**
 * 预览图片时禁止右键菜单
 * @param visible 预览显示开关
 */
export function useDisableContextMenu(visible: boolean): void {
  useEffect(() => {
    const disableContextMenu = (event: MouseEvent): void => {
      event.preventDefault();
    };

    if (visible) {
      document.addEventListener('contextmenu', disableContextMenu);
    } else {
      document.removeEventListener('contextmenu', disableContextMenu);
    }
    return (): void => {
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, [visible]);
}
